<template>
  <div id="app">
    <div
      class="header header-fixed unselectable header-animated header-dark no-print"
    >
      <div class="header-brand">
        <div class="nav-item no-hover">
          <img :src="branding.icon" :style="branding.iconstyle" />
        </div>
        <!-- Nav items for mobile and menus -->
        <div
          id="header-btn"
          class="nav-item nav-btn has-sub"
          v-on:click="toggle('profileDropdown')"
          v-bind:class="{ active: profileDropdown, hidden: !authenticated }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div
        id="header-menu"
        class="header-nav"
        v-if="authenticated"
        v-bind:class="{ active: profileDropdown }"
      >
        <div class="nav-item" v-on:click="hideDropdowns()">
          <router-link to="/">
            <span class="icon">
              <i class="fab fa-wrapper fas fa-tachometer-alt"></i>
            </span>
            Dashboard
          </router-link>
        </div>
        <div
          class="nav-item section-nav-item has-sub"
          v-bind:class="{ active: userDropdown }"
          v-if="permissions.includes('auth-taslytic.view_taslyticuser')"
        >
          <a class="nav-dropdown-link" v-on:click="toggle('userDropdown')">
            <span class="icon">
              <i class="fab fa-wrapper fas fa-users"></i>
            </span>
            Users
          </a>
          <ul
            class="dropdown-menu dropdown-animated"
            v-bind:class="{ 'dropdown-shown': userDropdown }"
            role="menu"
          >
            <li
              v-if="permissions.includes('auth-taslytic.view_taslyticuser')"
              role="menu-item"
              v-on:click="hideDropdowns()"
            >
              <router-link :to="{ name: 'user-index' }">
                <i class="fab fa-wrapper fas fa-list pad-right"></i>
                User Index
              </router-link>
            </li>
            <li
              v-if="permissions.includes('auth-taslytic.add_taslyticuser')"
              role="menu-item"
              v-on:click="hideDropdowns()"
            >
              <router-link :to="{ name: 'user-create' }">
                <i class="fab fa-wrapper fas fa-user-plus pad-right"></i>
                Create User
              </router-link>
            </li>
          </ul>
        </div>

        <div
          class="nav-item section-nav-item has-sub"
          v-bind:class="{ active: recordsDropdown }"
        >
          <a class="nav-dropdown-link" v-on:click="toggle('recordsDropdown')">
            <span class="icon">
              <i class="fab fa-wrapper fas fa-folder-open"></i>
            </span>
            Records
          </a>
          <ul
            class="dropdown-menu dropdown-animated"
            v-bind:class="{ 'dropdown-shown': recordsDropdown }"
            role="menu"
          >
            <li role="menu-item" v-on:click="hideDropdowns()">
              <router-link v-bind:to="{ name: 'record-index' }">
                <i class="fab fa-wrapper fas fa-list pad-right"></i>
                Record Index
              </router-link>
            </li>
            <li
              v-if="permissions.includes('records.add_record')"
              role="menu-item"
              v-on:click="hideDropdowns()"
            >
              <router-link v-bind:to="{ name: 'record-create' }">
                <i class="fab fa-wrapper fas fa-plus-square pad-right"></i>
                Create Record
              </router-link>
            </li>
            <li role="menu-item" v-on:click="hideDropdowns()">
              <router-link v-bind:to="{ name: 'scanned-record-index' }">
                <i class="fab fa-wrapper fas fa-images pad-right"></i>
                Scanned Records
              </router-link>
            </li>
            <li
              v-if="permissions.includes('courses.view_course')"
              role="menu-item"
              v-on:click="hideDropdowns()"
            >
              <router-link v-bind:to="{ name: 'course-index' }">
                <i class="fab fa-wrapper fas fa-graduation-cap pad-right"></i>
                Courses
              </router-link>
            </li>
            <li
              v-if="permissions.includes('records.view_record')"
              role="menu-item"
              v-on:click="hideDropdowns()"
            >
              <router-link v-bind:to="{ name: 'record-file-index' }">
                <i class="fab fa-wrapper fas fa-folder-open pad-right"></i>
                Training Record Files
              </router-link>
            </li>
          </ul>
        </div>

        <div
          class="nav-item section-nav-item has-sub"
          v-bind:class="{ active: examDropdown }"
        >
          <a class="nav-dropdown-link" v-on:click="toggle('examDropdown')">
            <span class="icon">
              <i class="fab fa-wrapper fas fa-clipboard-check"></i>
            </span>
            Exams
          </a>
          <ul
            class="dropdown-menu dropdown-animated"
            v-bind:class="{ 'dropdown-shown': examDropdown }"
            role="menu"
          >
            <li role="menu-item" v-on:click="hideDropdowns()">
              <router-link :to="{ name: 'exam-index' }">
                <i class="fab fa-wrapper fas fa-list pad-right"></i>
                Exam Index
              </router-link>
            </li>
            <li
              role="menu-item"
              v-on:click="hideDropdowns()"
              v-if="permissions.includes('exams.add_exam')"
            >
              <router-link :to="{ name: 'exam-create' }">
                <i class="fab fa-wrapper fas fa-plus-square pad-right"></i>
                Create Exam
              </router-link>
            </li>
            <li
              v-if="permissions.includes('exams.view_question')"
              role="menu-item"
              v-on:click="hideDropdowns()"
            >
              <router-link :to="{ name: 'question-index' }">
                <i class="fab fa-wrapper fas fa-question pad-right"></i>
                Question Index
              </router-link>
            </li>
          </ul>
        </div>
        <!-- Desktop user settings menu -->
        <div class="nav-right">
          <div
            class="nav-item has-sub"
            v-on:click="toggle('profileDropdown')"
            v-bind:class="{ active: profileDropdown }"
          >
            <a class="nav-dropdown-link">
              <span class="icon">
                <i class="fab fa-wrapper fas fa-user-cog"></i>
              </span>
            </a>
            <ul
              id="profile-menu"
              class="dropdown-menu dropdown-animated"
              v-bind:class="{ 'dropdown-shown': profileDropdown }"
              role="menu"
            >
              <div class="frame">
                <div class="frame__header">
                  <div class="tile">
                    <div class="tile__icon">
                      <strong>
                        <figure
                          class="avatar padded"
                          v-bind:data-text="initials"
                        ></figure>
                      </strong>
                    </div>
                    <div class="tile__container">
                      <p class="tile__title">
                        {{ userProfile.first_name }} {{ userProfile.last_name }}
                      </p>
                      <p class="tile__subtitle">
                        <strong>{{ userProfile.arn }}</strong>
                      </p>
                      <p class="tile__subtitle">
                        {{ userProfile.email }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="frame__footer">
                  <user-group-tags
                    v-bind:groups="userProfile.groups"
                    class="u-center"
                  ></user-group-tags>
                </div>
              </div>
              <li v-if="userProfile.is_staff" role="menu-item">
                <a href="/admin/">
                  <i
                    class="fa fa-wrapper fa-cog pad-right"
                    aria-hidden="true"
                  ></i>
                  Admin Settings
                </a>
              </li>
              <li>
                <a href="https://www.taslytic.com/docs/">
                  <i
                    class="fa fa-wrapper fa-ambulance pad-right"
                    aria-hidden="true"
                  ></i>
                  User Guide
                </a>
              </li>
              <li>
                <a href="mailto:admin@taslytic.com">
                  <i
                    class="fa fa-wrapper fa-bug pad-right"
                    aria-hidden="true"
                  ></i>
                  Report a Bug
                </a>
              </li>
              <div class="divider u-no-padding u-no-margin"></div>
              <li role="menu-item">
                <router-link v-if="userProfile" :to="getUserChangeLink()">
                  <i
                    class="fa fa-wrapper fa-user-cog pad-right"
                    aria-hidden="true"
                  ></i>
                  Edit Profile
                </router-link>
              </li>
              <li role="menu-item">
                <router-link to="/change-password">
                  <i
                    class="fa fa-wrapper fa-thumbtack pad-right"
                    aria-hidden="true"
                  ></i>
                  Change Password
                </router-link>
              </li>
              <li role="menu-item">
                <router-link to="/change-signature">
                  <i
                    class="fa fa-wrapper fa-unlock pad-right"
                    aria-hidden="true"
                  ></i>
                  Change Signature
                </router-link>
              </li>
              <div class="divider u-no-padding u-no-margin"></div>
              <li role="menu-item">
                <a v-on:click="logout">
                  <i
                    class="fa fa-wrapper fa-sign-out-alt pad-right"
                    aria-hidden="true"
                  ></i>
                  Log Out
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <offline-notification></offline-notification>
    <offline-icon></offline-icon>
    <router-view />
  </div>
</template>
<style>
:root {
  --cirrus-success: #12bb3f !important;
}
body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
#app {
  margin-top: 7.5rem;
  flex: 1;
}
.header-dark {
  background-color: #05062b;
  background: linear-gradient(#000, #05062b 70%);
}
.header .dropdown-menu {
  background-color: #05062b;
}
.header-brand {
  margin-right: 2rem;
}
.header-brand img,
#header-btn {
  height: 5rem;
}
.header-brand img {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.nav-item .icon {
  font-size: 1.5rem;
  margin-right: 0.75em;
  margin-bottom: 0.25em;
}
footer {
  background-color: #fff;
  background: linear-gradient(#05062b 5%, #000);
  padding: 3rem 0;
}
@media screen and (max-width: 639px) {
  #site-logo {
    float: none !important;
    display: block !important;
    width: 100%;
    height: auto !important;
    margin: 0 0 3rem;
  }
}
.u-no-margin-top {
  margin-top: 0;
}
.u-margin-right {
  margin-right: 1em;
}
.modal-content .modal-body {
  max-height: 60vh;
}
.hidden {
  display: none !important;
}
.toast {
  margin: 0.5em 0;
  opacity: 0.8;
}
.strong {
  font-weight: bold;
}
#profile-menu {
  padding: 0.5rem;
  min-width: 16em;
}
#profile-menu .tile {
  font-size: 50%;
}
#profile-menu .frame__footer {
  padding: 0.1rem;
  font-size: 85%;
}
#profile-menu .frame_footer,
#profile-menu .frame__header {
  padding: 0 0.75rem;
}
#profile-menu .tag-container {
  margin: 0.85rem 0 0;
}
#header-menu .nav-item li a i,
a span.icon {
  width: 2.5rem;
}
.tile .tile__subtitle {
  opacity: 1;
}
.--list-table-action-button {
  margin-top: 1.75rem;
}
button {
  font-size: 0.9rem;
}
button a {
  padding: 0;
  font-weight: 300;
}
button.outline.btn-info a {
  color: #2972fa;
}
button.outline a:hover {
  color: #f8f7ff;
}
.action-button {
  margin: 0 0 0 0.75rem;
  display: inline-block;
  white-space: nowrap;
}
a.action-button-link,
a.action-button {
  padding: 0;
}
.action-button i.fa-wrapper {
  vertical-align: middle;
}
.action-button a {
  font-weight: 300;
}
.tas-heading-button,
.tas-heading-button button {
  margin-top: 1rem;
  display: inline;
  margin-left: 0.5rem;
}
.u-inline-flex {
  display: inline-flex;
}
div.tag {
  margin-right: 0.5rem;
}
.tag.tag--delete {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  margin-left: 0.66rem;
  margin-right: 0;
  height: 1.5rem;
  max-height: 1.5rem;
  max-width: 1.5rem;
  min-height: 1.5rem;
  min-width: 1.5rem;
  border-radius: 5px;
}

.form-ext-label--no-label:after,
.form-ext-label--no-label:before {
  left: -0.85rem !important;
  top: -0.5rem !important;
}
.form-ext-control
  .form-ext-input.form-ext-input--warning:checked
  ~ .form-ext-label:before {
  background-color: var(--cirrus-warning);
}
.form-ext-control
  .form-ext-input.form-ext-input--dark:checked
  ~ .form-ext-label:before {
  background-color: var(--cirrus-dark);
}
table.table {
  border-collapse: unset;
}
table td.form-ext-control {
  display: table-cell;
}
table td.u-text-left,
table th.u-text-left {
  text-align: left !important;
}
th {
  background-color: #f8f9fa;
}
th,
td {
  vertical-align: middle !important;
}
td button {
  margin-bottom: 0;
}
td button.btn-small {
  line-height: 1.5rem !important;
}
button a {
  color: #f8f9fa;
}
button a:hover {
  color: #f8f7ff;
}
textarea {
  color: #5a5a5a;
  font-family: "Nunito Sans";
  font-size: 0.85rem;
}
#filterDropdown {
  padding-top: 2px;
}
.nav-item .dropdown-menu {
  font-size: inherit !important;
}
.dropdown-input {
  margin: 0.5rem 0 !important;
}
.dropdown-item {
  color: #5a5a5a !important;
  font-size: 0.85rem !important;
  padding: 0.85rem 1.1rem !important;
}
.section-nav-item {
  align-items: left;
  justify-content: left;
}
.section-nav-item .dropdown-menu.dropdown-animated {
  margin: 2px 0 0 -4px;
}
.input-control .icon i {
  color: var(--cirrus-dark-gray);
  padding-left: 1em;
}
.input-warning {
  background-color: rgb(224 155 0 / 5%) !important;
  border-color: var(--cirrus-warning) !important;
}

.fa-wrapper.pad-right {
  padding-right: 0.25rem;
}
.huge-icon {
  font-size: 32px !important;
}
.large-icon {
  font-size: 21px !important;
}
.normal-icon {
  font-size: 14px !important;
}
.small-icon {
  font-size: 11px !important;
}
.success {
  color: #0dd157;
  font-weight: bold;
}
.partial {
  color: #2368e9;
  font-weight: bold;
}
.selected {
  font-weight: bold;
  color: var(--cirrus-link-dark);
}
.error {
  color: #fb4143;
  font-weight: bold;
}
dd {
  margin-left: 1.5rem;
}
/* Handle how line breaks are shown in text */
.pre_line {
    white-space: pre-line;
}
/* Vue-multiselect styles */
.multiselect__element,
.multiselect__single,
.multiselect__placeholder,
.multiselect__tag,
.multiselect__input {
  font-size: 0.85rem !important;
  font-family: "Nunito Sans";
}
.multiselect__element,
.multiselect__single,
.multiselect__placeholder,
.multiselect__tag,
.multiselect__input {
  color: #5a5a5a;
  margin-bottom: 0;
}
.multiselect__single,
.multiselect__tag {
  margin-top: 4px;
}

i.multiselect__tag-icon {
  margin-top: -2px;
}
.multiselect__tags {
  height: 3rem;
  min-height: 3rem !important;
  padding-top: 4px !important;
}
input.multiselect__input {
  margin-top: 2px;
  border: none !important;
  max-height: 2rem;
}
div.multiselect--disabled div.multiselect__tags,
div.multiselect--disabled div.multiselect__tags span.multiselect__single {
  background-color: #ededed;
}
div.input-error div.multiselect__tags {
  background-color: rgba(244, 67, 54, 0.05) !important;
  border-color: var(--cirrus-danger) !important;
}
/* Media queries */
/* Fancy responsive data table =) */
@media screen and (max-width: 639px) {
  .content {
    width: 90% !important;
  }
  table td,
  table th {
    padding: 0.5rem !important;
  }
  .table {
    border: 0;
  }

  .table tr {
    display: block;
    border-top: 1px solid rgba(219, 219, 219, 0.5);
    border-bottom: 1px solid rgba(219, 219, 219, 0.5);
  }

  .table.bordered td,
  .table.bordered th,
  .table td,
  .table th {
    border-top: none !important;
    border-bottom: none !important;
  }

  .table td,
  .table th {
    display: block;
    font-size: 0.8em;
    text-align: right;
  }

  .table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  .table td:last-child {
    border-bottom: 5px red !important;
  }
}

@media only screen and (max-width: 1023px) {
  .tas-level-mobile-button {
    margin-top: -2rem;
  }
  .ignore-screen .input-control .icon i {
    padding-left: 1em;
  }
  :not(.ignore-screen).input-control .icon i {
    padding-left: 0;
  }
  ul.dropdown-menu li a {
    line-height: 3rem;
  }
  .dropdown-menu li {
    height: 4rem;
  }
  table td,
  table th {
    padding: 0.6rem !important;
  }
}
@media print {
  .no-print,
  .no-print *,
  button,
  .btn {
    display: none !important;
  }
}
</style>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import OfflineNotification from "@/components/OfflineNotification";
import OfflineIcon from "@/components/OfflineIcon";
import UserGroupTags from "@/components/UserGroupTags";

export default {
  data: function() {
    return {
      userDropdown: false,
      profileDropdown: false,
      examDropdown: false,
      recordsDropdown: false
    };
  },
  components: {
    OfflineNotification,
    OfflineIcon,
    UserGroupTags
  },
  methods: {
    toggle(param) {
      let body = document.getElementsByTagName("body")[0];
      let viewWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        body.clientWidth;
      if (viewWidth >= 769) {
        for (let menu in this._data) {
          if (menu != param) {
            Vue.set(this._data, menu, false);
          }
        }
      }
      Vue.set(this, param, !this[param]);
    },
    hideDropdowns() {
      for (const name in this._data) {
        Vue.set(this._data, name, false);
      }
    },
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push({ name: "login" });
      return;
    },
    getUserChangeLink() {
      let userId = this.userProfile.id;
      if (!userId) {
        userId = "#";
      }
      let data = {
        name: "user-change",
        params: { userId: userId }
      };
      return data;
    }
  },
  computed: {
    ...mapGetters("auth", ["userProfile", "permissions", "authenticated"]),
    ...mapGetters("core", ["branding", "aircraft"]),
    initials() {
      if (this.userProfile.first_name && this.userProfile.last_name) {
        return (
          this.userProfile.first_name.slice(0, 1) +
          this.userProfile.last_name.slice(0, 1)
        );
      } else {
        return "";
      }
    }
  },
  mounted() {
    // Setup the icon and logo files to control the branding via .env files =)
    this.$store.commit("core/setBranding", {
      icon: require(`@/assets/${process.env.VUE_APP_ICON}`),
      logo: require(`@/assets/${process.env.VUE_APP_LOGO}`),
      iconstyle: process.env.VUE_APP_ICON_STYLE,
      logostyle: process.env.VUE_APP_LOGO_STYLE
    });
    // Event listener to close modal dialogs and dropdowns when the Escape key
    // is pressed
    const self = this;
    document.addEventListener("keyup", function(e) {
      if (e.key === "Escape") {
        const modals = document.querySelectorAll(".modal-overlay");
        for (const modal of modals) {
          modal.click();
        }
        // Reset the dropdown visibility values to hide the dropdowns =)
        self.hideDropdowns();
      }
    });
    /* Hydrate all UI data using the cache */
    this.$store.commit("core/setResults", this.$offlineStorage.get("results"));
    this.$store.commit(
      "core/setAircraft",
      this.$offlineStorage.get("aircraft")
    );
    this.$offlineStorage.get("users")
      ? this.$store.commit("auth/setUsers", this.$offlineStorage.get("users"))
      : null;
    this.$offlineStorage.get("userList")
      ? this.$store.commit(
          "auth/setUsers",
          this.$offlineStorage.get("userList")
        )
      : null;
    this.$offlineStorage.get("userProfile")
      ? this.$store.commit(
          "auth/setUserProfile",
          this.$offlineStorage.get("userProfile")
        )
      : null;
    this.$offlineStorage.get("permissions")
      ? this.$store.commit(
          "auth/setPermissions",
          this.$offlineStorage.get("permissions")
        )
      : null;
  }
};
</script>
